(function () {
  function initSlider(el) {
    var $slider = jQuery(el);
    if ($slider.hasClass('slick-initialized')) return;

    var columnsDesktop = parseInt(el.dataset.columnsDesktop, 10) || 3;
    var columnsTablet = parseInt(el.dataset.columnsTablet, 10) || 2;
    var columnsMobile = parseInt(el.dataset.columnsMobile, 10) || 1;
    var autoplay = el.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(el.dataset.autoplaySpeed, 10) || 5000;
    var slideCount = $slider.children().length;

    $slider.slick({
      slidesToShow: Math.min(columnsDesktop, slideCount),
      slidesToScroll: columnsDesktop,
      dots: slideCount > columnsMobile,
      arrows: false,
      infinite: slideCount > columnsDesktop,
      autoplay: autoplay,
      autoplaySpeed: autoplaySpeed,
      // Keep autoplay running regardless of hovering, dragging, or a dot/arrow
      // holding focus after a click - otherwise it looks like autoplay "stops"
      // whenever the cursor rests on the slider or a nav control keeps focus.
      pauseOnHover: false,
      pauseOnFocus: false,
      pauseOnDotsHover: false,
      speed: 500,
      swipe: true,
      draggable: true,
      responsive: [
        {
          // Tablet (750px–989px): use the merchant-configured tablet column count.
          breakpoint: 989,
          settings: {
            slidesToShow: Math.min(columnsTablet, slideCount),
            slidesToScroll: Math.min(columnsTablet, slideCount),
            infinite: slideCount > Math.min(columnsTablet, slideCount),
          },
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: Math.min(columnsMobile, slideCount),
            slidesToScroll: columnsMobile,
            infinite: slideCount > columnsMobile,
          },
        },
      ],
    });
  }

  function destroySlider(el) {
    var $slider = jQuery(el);
    if ($slider.hasClass('slick-initialized')) $slider.slick('unslick');
  }

  function initAll(container) {
    (container || document).querySelectorAll('.customer-reviews__slick').forEach(initSlider);
  }

  initAll();

  // Re-init when a merchant edits this section's blocks/settings in the theme
  // editor, since slick reads slide count/columns once at init time and won't
  // pick up live changes on its own.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('.customer-reviews__slick').forEach(destroySlider);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slider = event.target.closest ? event.target.closest('.customer-reviews__slick') : null;
    if (slider && jQuery(slider).hasClass('slick-initialized')) {
      var index = Array.prototype.indexOf.call(slider.children, event.target);
      if (index > -1) jQuery(slider).slick('slickGoTo', index);
    }
  });
})();
